import React from 'react';
import { Header, Segment, Tab, Loader, Button, Icon, Popup } from 'semantic-ui-react';
import axios from 'axios/index';
import { Link } from 'react-router-dom';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive/index';
import moment from 'moment';
import { IconHeader } from '../../../Assets/util/css';

export default class StaffPollCourseReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            activeIndex: (localStorage.getItem('activeIndex') && localStorage.getItem('activeIndex') !== 'null') ? localStorage.getItem('activeIndex') : 0
        };
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <Header as="h1"> Izvještaji </Header>

                <Segment.Group clearing raised>
                    <Segment>
                        <Header as="h3">
                            Predmeti
                            <Header style={IconHeader} floated="right">
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left" onClick={() => window.history.go(-1)} />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader>
                                {(localStorage.getItem('questionnaireData')) === 'null' ? ' ' : localStorage.getItem('questionnaireData')}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/Reports/SectionReports/StaffPollCourseReport.js